import { render } from "./TipStatPage.vue?vue&type=template&id=ee2c3798"
import script from "./TipStatPage.vue?vue&type=script&lang=js"
export * from "./TipStatPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__